import { getCurrentTheme } from 'utils/themeUtils';

export default {
  nextTheme: ({
    position: {
      next: { theme=undefined } = {}
    } = {}
  }) => {
    const themeId = typeof theme === 'object' ? theme.id : theme;
    return getCurrentTheme(themeId);
  },

  previousTheme: ({
    position: {
      last: { theme=undefined } = {}
    } = {}
  }) => {
    const themeId = typeof theme === 'object' ? theme.id : theme;
    return getCurrentTheme(themeId);
  },
  sessionId: state => (state.sessionId ? state.sessionId : null)
};
